import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export const phonesWorkMobileDialogDef = {
  type: "phones",
  dialogLabel: "MY_HR_EDIT_PHONES_WORK_MOBILE",
  mutation: MY_HR_CREATE_CHANGE_REQUEST,
  items: [
    {
      label: "OC_VALIDITY",
      name: "validFrom",
      type: "datePicker",
      validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_PHONE_WORKMOBILE",
      name: "workMobilePhone",
      dataField: "workMobile",
      type: "text",
      validation: Yup.string().test(
        "test-name",
        "MY_HR_NOT_VALID_PHONE_NUMBER",
        function (value) {
          if (!value) return true;
          const parsedValue = value
            .replaceAll(/\s/g, "")
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "");
          let isNum = /^\d+$/.test(parsedValue);
          if ((parsedValue.length === 8 || parsedValue.length === 9) && isNum) {
            return true;
          }
          return false;
        },
      ),
      inputAdornment: "+36",
    },
    {
      label: "OC_MESSAGE",
      name: "initialMessage",
      type: "textarea",
      validation: Yup.string(),
    },
  ],
};
